module.exports = __webpack_public_path__ + "static/grafika3-b1e99136e855fef204d0a75578e5a3b1.png";